export default __webpack_public_path__ + "static/media/how_it_work_hero.bb062496.png";